import { Image, ImageSourcePropType, StyleSheet } from "react-native";
import React, { useMemo } from "react";
import { useTheme } from "../hooks/use-theme";
import Text from "./Text";
import { SvgProps } from "react-native-svg";

type EmptyScreenProps = {
    text?: string;
    image: ImageSourcePropType | React.FC<SvgProps>;
};

export const EmptyText = ({ text }: { text: string }) => {
    const styles = useStyles();
    return <Text style={styles.mainTitle}>{text}</Text>;
};

const EmptyScreen = ({ image: PropsImage, text }: EmptyScreenProps) => {
    const styles = useStyles();

    return (
        <>
            {/* Is SVG */}
            {typeof PropsImage === "function" ? (
                <PropsImage width="100%" />
            ) : (
                <Image style={styles.emptyImage} source={PropsImage} />
            )}
            {text && <EmptyText text={text} />}
        </>
    );
};

const useStyles = () => {
    const { gridSize, fonts, colors } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                emptyImage: {
                    flex: 0,
                    resizeMode: "contain",
                    alignSelf: "center",
                    aspectRatio: 1.0,
                    height: 300,
                },
                mainTitle: {
                    padding: gridSize / 2,
                    textAlign: "center",
                    ...fonts.titleSmall,
                    color: colors.fieldLabel,
                },
            }),
        [gridSize, fonts.titleSmall, colors.fieldLabel],
    );
};

export default EmptyScreen;
